module.exports = __webpack_public_path__ + "img/industry_3.0f4a8f12.png";